import {
  orangeShades,
  primaryColors,
  whiteShades
} from '@assets/styles/helpers/colors.styles'

export const stepperStyles = {
  '.MuiStepIcon-root': {
    cursor: 'pointer',
    color: whiteShades.shade1,
    '&.Mui-active': {
      color: primaryColors.white,
      '&.Mui-error': {
        color: `${primaryColors.orange} !important`
      }
    },
    '&.Mui-completed': {
      color: whiteShades.shade1
    },
    '&.Mui-error': {
      color: `${orangeShades.shade2} !important`
    }
  },
  '.MuiStepIcon-text': {
    fill: primaryColors.black,
    fontFamily: `"helvetica-neue-lt-pro", sans-serif`,
    fontWeight: 900
  },
  '.MuiStepConnector-line': {
    borderColor: whiteShades.shade1
  }
}

export const stepperLabelStyles = {
  '.MuiStepLabel-label': {
    cursor: 'pointer',
    color: whiteShades.shade1,
    margin: '0 !important',
    paddingTop: '0.5rem !important',
    '&.Mui-active': {
      color: primaryColors.white,
      '&.Mui-error': {
        color: `${primaryColors.orange} !important`
      }
    },
    '&.Mui-completed': {
      color: whiteShades.shade1
    },
    '&.Mui-error': {
      color: `${orangeShades.shade2} !important`
    }
  }
}
